import { Component, input, OnInit, inject } from '@angular/core';
import { FeedbackTitleComponent } from '../feedback-title/feedback-title.component';
import { ControlContainer, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { QuestionItem } from '../../feedback-types';
import { wildcardId } from '../../../../utils/feedback/feedback';

@Component({
  selector: 'app-feedback-text-area',
  imports: [FeedbackTitleComponent, ReactiveFormsModule],
  templateUrl: './feedback-text-area.component.html',
  styleUrl: './feedback-text-area.component.css',
})
export class FeedbackTextAreaComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  public question = input.required<QuestionItem>();
  protected form!: FormGroup;
  protected text = '';

  ngOnInit(): void {
    this.form = this.controlContainer.control as FormGroup;
    const control = this.form.get(this.question().id);
    if (control) {
      this.text = (control.value ?? '').slice(wildcardId.length);
      control.setValue(wildcardId + this.text);
    }
  }

  protected updateText(event: Event): void {
    this.text = (event.target as HTMLTextAreaElement).value;
    this.form.get(this.question().id)?.setValue(wildcardId + this.text);
  }
}
